/* eslint-disable no-param-reassign */
/* eslint-disable fp/no-mutation */
/**
 * Calendar Configuration
 */

import {StringHelper} from '@bryntum/calendar';
import Event from './EventModel';

const eventRenderer = ({eventRecord}) => `
          <span class="b-event-name"><b>${StringHelper.encodeHtml(eventRecord.name)}</b></span>
          <span>${StringHelper.encodeHtml(eventRecord.location)}</span>
        `;

const calendarConfig = (profileId, isMobile, isViewer) => ({
  // CrudManager arranges loading and syncing of data in JSON form from/to a web service
  crudManager: {
    autoLoad: true,
    autoSync: true,
    eventStore: {
      modelClass: Event,
    },
    transport: {
      load: {
        url: `${process.env.REACT_APP_FIREBASE_URL}calendarLoad/${profileId}`,
      },
      sync: {
        url: `${process.env.REACT_APP_FIREBASE_URL}calendarSync/${profileId}`,
      },
    },
    listeners: {
      beforeSync(beforeSyncEvent) {
        const eventStoreChanges = beforeSyncEvent?.pack?.events;
        // Prevent sync if no event changes are present
        if (!eventStoreChanges || (Array.isArray(eventStoreChanges) && eventStoreChanges.length === 0)) {
          return false;
        }

        // Validate added events for required resourceId
        const addedEvents = eventStoreChanges.added || [];
        if (addedEvents.some(event => !event.resourceId)) {
          return false;
        }

        // Validate updated events for required resourceId
        const updatedEvents = eventStoreChanges.updated || [];

        // If there are updated events, iterate through them
        if (updatedEvents) {
          updatedEvents.forEach(updatedEvent => {
            // Check if resourceId is null or undefined
            if (updatedEvent.resourceId == null) {
              // Delete the key from the object being sent to the server
              // eslint-disable-next-line fp/no-mutation, fp/no-delete
              delete updatedEvent.resourceId;
            }
          });
        }

        // Validate assignmentStore changes if present
        const assignmentStoreChanges = eventStoreChanges.assignmentStore;
        if (assignmentStoreChanges?.added?.some(a => !a.resourceId || !a.eventId)) {
          return false;
        }

        return true;
      },
    },
  },
  dateFormat: 'D/MM/YYYY',
  readOnly: isViewer,
  weekStartDay: 1,
  // Modes are the views available in the Calendar.
  // An object may be used to configure the view.
  // null means do not include the view.
  mode: isMobile ? 'agenda' : 'week',
  modes: {
    // agenda: null,
    // month: null,
    // year: null,
    day: {
      // hourHeight: 64,
      // These two settings decide what time span is rendered
      dayStartTime: 0,
      dayEndTime: 24,
      // Scroll to 7am initially
      visibleStartTime: 7,
      eventRenderer,
      weekStartDay: 1,
    },
    week: {
      // hourHeight: 64,
      // These two settings decide what time span is rendered
      dayStartTime: 0,
      dayEndTime: 24,
      // Scroll to 7am initially
      visibleStartTime: 7,
      eventRenderer,
      weekStartDay: 1,
    },
    month: {
      eventRenderer,
      weekStartDay: 1,
    },
    year: {
      eventRenderer,
      weekStartDay: 1,
    },
    agenda: {
      range: 'week',
      eventRenderer,
    },
  },
  allowOverlap: true,
  // sidebar: {
  //   collapsed: true,
  // },
  eventEditFeature: {
    dateFormat: 'DD/MM/YYYY',
    items: {
      location: {
        type: 'textfield',
        name: 'location',
        label: 'Location',
        weight: 210,
      },
      noteField: {
        type: 'textarea',
        label: 'Notes',
        name: 'note',
      },
      resourceField: {
        label: 'Calendar',
        name: 'resourceId',
        multiSelect: false,
        required: true,
        validators: [
          {
            fn: (value, field) => {
              if (!value) {
                return 'Please selected a calendar';
              }
              return true; // Validation passed
            },
            // This message will be shown if the validator returns false
            message: 'Please selected a calendar',
          },
        ],
      },
    },
  },
});

export default calendarConfig;
